var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSell = function SvgSell(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h32v32H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 28.533c-.51.511-1.144.767-1.9.767-.755 0-1.389-.256-1.9-.767L3.467 16.8a2.768 2.768 0 0 1-.583-.867 2.654 2.654 0 0 1-.217-1.066V5.332c0-.733.261-1.36.783-1.883a2.568 2.568 0 0 1 1.884-.784h9.533c.378 0 .733.073 1.067.217.333.145.622.34.866.583l11.734 11.767c.51.511.766 1.14.766 1.883 0 .745-.255 1.373-.766 1.884L19 28.533Zm-1.9-1.867 9.534-9.533-11.767-11.8H5.334v9.534l11.766 11.8Zm-8.433-16c.556 0 1.028-.194 1.417-.583a1.93 1.93 0 0 0 .583-1.417c0-.555-.194-1.027-.583-1.416a1.929 1.929 0 0 0-1.417-.583c-.556 0-1.028.194-1.417.583a1.929 1.929 0 0 0-.583 1.416c0 .556.194 1.028.583 1.417.39.39.861.583 1.417.583Z",
    fill: "#F92"
  }))));
};
export default SvgSell;